import {
	useState,
} from 'react';
import {
	Offcanvas,
} from 'react-bootstrap';
import Button, {
	ButtonColor,
} from 'components/button';
import {
	UserSupport,
	Support,
} from 'components/support';
import './navigation.scss';
import {
	useLiveQuery,
} from 'dexie-react-hooks';
import {
	database,
	SettingKey,
	TableName,
} from 'utils/database';


import {
	showToastIfNotInstalled,
} from 'utils/install/utils';
import {
	SvgMenuBurger,
} from 'components/svg/Svg';
import {
	useAuthService,
} from '../../services';

// TODO: Need to show app version when we bump versions for each release
// import packageJson from '../../../package.json';
// ,and then: (v{packageJson.version})

const updateSettings = async (key: SettingKey, value: string) => await database.settings.put({
	key, value,
});

const removeData = async (table: TableName) => await database[table].clear();

const clearCache = () => {
	removeData(TableName.ASSIGNMENTS);
	removeData(TableName.DEVIATIONS);
	removeData(TableName.API_QUEUE);
	removeData(TableName.SYNC_DATA);
	removeData(TableName.SYNC_NOTIFICATION);
	removeData(TableName.SETTINGS);
	showToastIfNotInstalled();
}

const Menu = () => {
	// const {
	// 	translate,
	// 	translation,
	// 	setLanguage,
	// 	chosenLanguage,
	// 	Languages,
	// } = useLanguage();
	const [show, setShow] = useState(false);
	const phone = useLiveQuery(() => database.settings.get(SettingKey.PHONE));
	const {
		logout,
	} = useAuthService();
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	/*
	const fakeTempLanguageSetting = () => {
		setLanguage(chosenLanguage === Languages.EN ? Languages.NO : Languages.EN);
	}
	*/

	return (
		<>
			<div className="app-header">
				<div className="app-header-menu">
					<Button color={ButtonColor.NONE} onClick={handleShow}>
						<SvgMenuBurger />
					</Button>
				</div>
				<div className="app-header-title">
					Mine oppdrag{/*translate(translation.MY_ASSIGNMENTS)*/}
				</div>
				<div className="app-header-status" />
			</div>

			<Offcanvas show={show} onHide={handleClose} className="app-menu">
				<Offcanvas.Header closeButton>
					<Offcanvas.Title />
				</Offcanvas.Header>
				<Offcanvas.Body>
					<div className="app-menu-profile">
						<div className="app-menu-profile-avatar">
							B{/*translate(translation.USER_U)*/}
						</div>
						<div className="app-menu-profile-text">
							<div className="app-menu-profile-text-name" data-private>
								Bruker{/*translate(translation.USER)*/}
							</div>
							<div className="app-menu-profile-text-username" data-private>
								{phone?.value}
							</div>
						</div>
					</div>

					<hr />

					<div className="app-menu-menu-group">
						<div className="app-menu-menu-group-item">
							<Button
								color={ButtonColor.NONE}
								onClick={handleClose}
							>
								Mine oppdrag{/*translate(translation.MY_ASSIGNMENTS)*/}
							</Button>
						</div>
					</div>

					<hr />

					<div className="app-menu-menu-group">
						<div className="app-menu-menu-group-item">
							<Button color={ButtonColor.NONE} onClick={() => logout()}>Logg ut{/*translate(translation.LOG_OUT)*/}</Button>
						</div>
					</div>

					<hr />
					<div className="app-menu-menu-group support-id">
						<div className="app-menu-menu-group-item">
							<Button
								color={ButtonColor.NONE}
								onClick={() => clearCache()}
							><small>clear cache</small>
							</Button>
							<hr/>
							<div style={{
								fontSize: '14px', /*Need to override text-size styling from the parten stylesheet*/
							}}>
								<UserSupport phone="+4795129999" phoneText="+47 951 29 999" />
							</div>
							<Support />
						</div>
					</div>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
}

export default Menu;